module.exports = __webpack_public_path__ + "static/media/VectorPointPendent.85a5171d.svg";